import { BBCodeEditor } from "app/common/editor";
import * as $ from "jquery";

export class Thread {
    private editor: BBCodeEditor;

    public constructor(editor: BBCodeEditor) {
        this.editor = editor;
    }

    public quotePost(id: string, username: string) {
        const postDom = $('#post-' + id);
        if (postDom == null) {
            return false;
        }

        const content = postDom.find('.raw').html();
        this.editor.insertQuote(content, username);
    }
}
